export default {
	methods: {
		getFirstImage(images){
			if(typeof images !== "undefined" && images.length > 0){
				return images[0]
			}
			return 'placeholder';
		},
		getImage(id,size)
		{
			if(id === 'placeholder'){
				return '/gg-placeholder.svg';
			}
			return 'https://images.rw.guloggratis.dk/image/'+size+'/'+id+'.jpg'
		},
		getPrice(price)
		{
			return Number(price).toFixed(2).replace('.',",");
		}
	}
}
